import api from 'services/api';

export const getCameraSnapshot = (snapshotUrl: string): Promise<string> => {
  return api.request({
    baseURL: '',
    url: snapshotUrl
  })
}
